export enum Routes {
  CANCEL_PICKUP = 'bins/pickup-request',
  REQUEST_PICKUP = 'bins/pickup-request',
  GET_BINS = 'bins',
  GET_BINS_HISTORY = 'bins/history',
  GET_TRUCKS = 'bins/trucks',
  UPDATE_BIN = 'bins/bin',
}
